import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Gallery } from './pages/Gallery';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Faq } from './pages/Faq';
import { Legal } from './pages/Legal';
import { NotFound } from './pages/NotFound';
import { useLocalBusinessSchema } from './hooks/useSeo';
interface AppProps {
  defaultLanguage?: 'en' | 'es';
}
export function App({
  defaultLanguage = 'en'
}: AppProps) {
  useLocalBusinessSchema();
  return <LanguageProvider initialLanguage={defaultLanguage} data-id="element-0" data-mp="2wjqhr811w6n6">
      <BrowserRouter data-id="element-1" data-mp="2wi5n7ieqknpb">
        <Routes data-id="element-2" data-mp="28u5zkrcq1dey">
          <Route element={<Layout data-id="element-4" data-mp="28te3zgj4jfoo" />} data-id="element-3" data-mp="28tmg367fagyt">
            <Route path="/" element={<Home data-id="element-6" data-mp="28s31dk1f0dz5" />} data-id="element-5" data-mp="28sl4n0mhvsgk" />
            <Route path="/services" element={<Services data-id="element-8" data-mp="23ujl6el5pr4k" />} data-id="element-7" data-mp="23vupqgmff2wq" />
            <Route path="/gallery" element={<Gallery data-id="element-10" data-mp="3ik7k0rkruvvx" />} data-id="element-9" data-mp="23t8gmcjw0fce" />
            <Route path="/about" element={<About data-id="element-12" data-mp="3ijpe138b53at" />} data-id="element-11" data-mp="3iiwfuqnezm4a" />
            <Route path="/contact" element={<Contact data-id="element-14" data-mp="3mkrbpfmkt7ao" />} data-id="element-13" data-mp="3mljat0fdtn5p" />
            <Route path="/faq" element={<Faq data-id="element-16" data-mp="3mj6ibtbzzuee" />} data-id="element-15" data-mp="3mjzs7369700r" />
            <Route path="/privacy" element={<Legal kind="privacy" data-id="element-18" data-mp="3rdar8i4tqci4" />} data-id="element-17" data-mp="3rcj7q5oi4587" />
            <Route path="/terms" element={<Legal kind="terms" data-id="element-20" data-mp="5os92t1uy7l" />} data-id="element-19" data-mp="3recctgjguhe3" />
            <Route path="*" element={<NotFound data-id="element-22" data-mp="82ld64660ci" />} data-id="element-21" data-mp="4n6o4eeqtbm" />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}